import { motion } from "framer-motion";
import { MapPin, Users, ShieldCheck } from "lucide-react";

const PILLARS = [
  {
    no: "03",
    icon: MapPin,
    title: "Forty Years of Local Roots",
    body: "We're not a franchise. We've lived, worked, and raised our family in Saint Lucie for four decades — your neighbors, literally.",
  },
  {
    no: "04",
    icon: Users,
    title: "One Crew. No Subcontractors.",
    body: "The same trusted faces arrive every visit. Whoever quotes the job is who completes it — cleaning and repairs, start to finish.",
  },
  {
    no: "05",
    icon: ShieldCheck,
    title: "Licensed & Insured",
    body: "LLC #L26000381246. Fully covered on every job, so your home is protected while we make it shine.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="relative bg-[#0F172A] pt-16 lg:pt-20 pb-28 lg:pb-36 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-[0.06] [background:radial-gradient(#FDFBF7_1px,transparent_1px)] [background-size:26px_26px]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-jet text-[11px] uppercase tracking-[0.3em] text-[#D96B43] mb-16"
        >
          The His &amp; Hers Promise
        </motion.p>

        <div className="space-y-0">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.no}
              data-testid={`manifesto-pillar-${p.no}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              className="group grid md:grid-cols-12 gap-6 items-baseline py-10 border-t border-[#FDFBF7]/12 last:border-b"
            >
              <h3 className="md:col-span-5 font-display text-2xl lg:text-3xl text-[#FDFBF7] tracking-tight flex items-center gap-3">
                <p.icon size={22} className="text-[#D96B43] shrink-0" />
                {p.title}
              </h3>
              <p className="md:col-span-7 text-[#94A3B8] leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
